module.exports = __webpack_public_path__ + "img/tel1.fd3150c1.png";